var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('rabbey-toolbox',{attrs:{"filterables":true},on:{"filter-search":_vm.handleSearch}}),_c('rabbey-table2',{ref:"table",attrs:{"index-url":"/api/deviceAssignations","key-search":"CustomerName","search":_vm.search,"filterList":_vm.custList,"columns":_vm.columns}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }